import { Box, Checkbox, Flex, IconButton, Text } from '@chakra-ui/react';
import { camelCase } from 'lodash';
import Tooltip from '~/components/Tooltip';
import { InfoNoBorderIcon } from '~/components/icons';

import { totalAudience } from '../LastUpdatedPlatform/LastUpdatedPlatform.constants';
import { getBoxStyles } from './MediaPackDetailHighlightCheckboxCard.styles';
import { THighlightCheckboxCard } from './MediaPackDetailHighlightCheckboxCard.types';

export const MediaPackDetailHighlightCheckboxCard: React.FC<
  THighlightCheckboxCard
> = ({
  description,
  isChecked,
  isDisabled,
  onChange,
  position,
  title,
  transformValue,
  value,
  metricKey,
  lastUpdated,
}) => {
  const styles = getBoxStyles({ isChecked, isDisabled });
  return (
    <Box
      cursor="pointer"
      data-disabled={isDisabled ? '' : undefined}
      data-testid={`${camelCase(title)}-checkbox`}
      onClick={() => onChange(!isChecked)}
      position="relative"
      pointerEvents={isDisabled ? 'none' : 'inherit'}
    >
      <Flex
        minHeight="94px"
        padding={4}
        height="full"
        flexDir="column"
        justifyContent="space-between"
        {...styles}
      >
        <Flex alignItems="center">
          <Text>{title}</Text>
          {!!description && (
            <Tooltip
              marginLeft="auto"
              label={description}
              fontSize="md"
              isTouchFriendly
            >
              <IconButton
                _hover={{
                  color: 'secondary.500',
                }}
                variant="link"
                aria-label=""
                color="primary.500"
                icon={<InfoNoBorderIcon boxSize="16px" />}
              />
            </Tooltip>
          )}
        </Flex>

        <Text
          data-testid={`${camelCase(title)}-value`}
          fontWeight={500}
          fontSize="lg"
        >
          {transformValue ? transformValue(value) : value}
        </Text>
        {!(metricKey && totalAudience.includes(metricKey)) && (
          <Text
            color={'primary.400'}
            fontSize="sm"
            fontWeight={400}
            marginTop={2}
          >
            {lastUpdated}
          </Text>
        )}
        <Box textAlign={'right'}>
          <Checkbox
            pointerEvents="none"
            colorScheme="secondary"
            icon={
              position ? (
                <Text fontSize="xs" fontWeight={500}>
                  {position}
                </Text>
              ) : undefined
            }
            isChecked={isChecked}
            opacity={isDisabled ? 0.2 : 1}
            minHeight={1}
            verticalAlign={'middle'}
          />
        </Box>
      </Flex>
    </Box>
  );
};
